import { useGateway } from '@ad-lucy/gateway-provider';
import { getAppConfig } from '@modules/config/appConfig';
import { ModuleClientReporting } from '@modules/remotes/clientReporting';
import { useMemo } from 'react';
import type { MfClientReportingAppConfig } from './ClientReporting.types';

function ClientReporting() {
  const appConfig = getAppConfig();
  const gateway = useGateway();

  const clientReportingAppConfig = useMemo<MfClientReportingAppConfig>(
    () => ({
      API_ROOT: appConfig.API_ROOT,
      IMG_URL: appConfig.IMG_URL,
      THEME_DEFAULT: appConfig.THEME_DEFAULT,
      THEME_URL: appConfig.THEME_URL,
    }),
    [appConfig],
  );

  return (
    <ModuleClientReporting
      appConfig={clientReportingAppConfig}
      gateway={gateway}
    />
  );
}

export default ClientReporting;
